import React from 'react';

interface TagsProps {
  tags: string[] | undefined;
}

/**
 * Simple readonly component for a rendering list of tags that are passed as an array of strings
 */
const SimpleTagList = (props: TagsProps) => {
  return (
    <div className="picked">
      {props.tags &&
        props.tags.map((tag: string, index: number) => {
          return (
            <span key={index} className="picked-item mr-2" title={tag}>
              {tag}
            </span>
          );
        })}
    </div>
  );
};

export default SimpleTagList;
